import React, { useEffect, useState } from 'react';
import { useUser } from "@clerk/clerk-react";

const OrderModal = ({ show, handleClose, onSubmit, product }) => {
    const { isLoaded, isSignedIn, user } = useUser();

    const [formData, setFormData] = useState({
        name: '',
        email:'',
        phoneNumber: '',
        address: '',
        product:product._id,
        pre_order:product.pre_order
    });

    useEffect(() => {
        if (show && isLoaded && isSignedIn && user) {
            setFormData({
                name: user.fullName || "",
                email: user.primaryEmailAddress?.emailAddress || "",
                phoneNumber: '',
                address: '',
                product:product._id,
                pre_order:product.pre_order
            });
        }
    }, [show, isLoaded, isSignedIn, user]);

    const handleChange = (e) => {
        const { name, value } = e.target;
        setFormData(prevState => ({
            ...prevState,
            [name]: value
        }));
    };

    const handleSubmit = (e) => {
        e.preventDefault();
        onSubmit(formData);
        handleClose();
    };

    if (!show) return null;

    return (
        <>
            <div className="modal fade show" style={{ display: 'block', backgroundColor: 'rgba(0,0,0,0.5)' }} tabIndex="-1" aria-labelledby="orderModalLabel" aria-hidden="true">
                <div className="modal-dialog">
                    <div className="modal-content">
                        <div className="modal-header">
                            <h5 className="modal-title" id="orderModalLabel">Order {product.prod_name}</h5>
                            <button type="button" className="btn-close" onClick={handleClose} aria-label="Close"></button>
                        </div>
                        <div className="modal-body">
                            <form onSubmit={handleSubmit}>
                                <div className="mb-3">
                                    <label htmlFor="name" className="form-label">Name</label>
                                    <input
                                        type="text"
                                        className="form-control"
                                        id="name"
                                        name="name"
                                        value={formData.name}
                                        onChange={handleChange}
                                        placeholder='Ram Bahadur'
                                        required
                                    />
                                </div>
                                <div className="mb-3">
                                    <label htmlFor="email" className="form-label">Email Address</label>
                                    <input
                                        type="email"
                                        className="form-control"
                                        id="email"
                                        name="email"
                                        value={formData.email}
                                        onChange={handleChange}
                                        placeholder='ram@gmail.com'
                                        required
                                        // Optional: readOnly if you don't want them to change it
                                        // readOnly 
                                    />
                                </div>
                                <div className="mb-3">
                                    <label htmlFor="phoneNumber" className="form-label">Phone Number</label>
                                    <input
                                        type="tel"
                                        className="form-control"
                                        id="phoneNumber"
                                        name="phoneNumber"
                                        value={formData.phoneNumber}
                                        onChange={handleChange}
                                        placeholder='9XXXXXXXX'
                                        required
                                    />
                                </div>
                                <div className="mb-3">
                                    <label htmlFor="address" className="form-label">Address</label>
                                    <textarea
                                        className="form-control"
                                        id="address"
                                        name="address"
                                        rows="3"
                                        value={formData.address}
                                        onChange={handleChange}
                                        placeholder='Thimi'
                                        required
                                    ></textarea>
                                </div>
                                <div className="modal-footer px-0 pb-0">
                                    <button type="button" className="btn btn-secondary" onClick={handleClose}>Close</button>
                                    <button type="submit" className="btn btn-primary">Place Order</button>
                                </div>
                            </form>
                        </div>
                    </div>
                </div>
            </div>
        </>
    );
};

export default OrderModal;
